import { TabCommunicationBroadcastChannel } from './TabCommunicationBroadcastChannel.ts';
import { TabCommunicationLocalStorage } from './TabCommunicationLocalStorage.ts';
export var TabCommunicationEvent = /*#__PURE__*/ function(TabCommunicationEvent) {
    TabCommunicationEvent[TabCommunicationEvent["ReloadWebsite"] = 0] = "ReloadWebsite";
    return TabCommunicationEvent;
}({});
export class TabCommunication {
    static createTabCommunication() {
        if (TabCommunicationBroadcastChannel.isAvailable()) return new TabCommunicationBroadcastChannel();
        return new TabCommunicationLocalStorage();
    }
}
